class s extends Error {
  constructor(o, r) {
    super(`${r ? r + ". " : ""}${o}`), this.computeNodeName = r, this.name = "DataRoomComputationError", this.computeNodeName = r;
  }
}
export {
  s as DataRoomComputationError
};
//# sourceMappingURL=DataRoomComputationError.js.map
